import { render, staticRenderFns } from "./keepMaterialAdmin.vue?vue&type=template&id=4813336c&scoped=true&"
import script from "./keepMaterialAdmin.vue?vue&type=script&lang=js&"
export * from "./keepMaterialAdmin.vue?vue&type=script&lang=js&"
import style0 from "./keepMaterialAdmin.vue?vue&type=style&index=0&id=4813336c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4813336c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4813336c')) {
      api.createRecord('4813336c', component.options)
    } else {
      api.reload('4813336c', component.options)
    }
    module.hot.accept("./keepMaterialAdmin.vue?vue&type=template&id=4813336c&scoped=true&", function () {
      api.rerender('4813336c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/materialOrder/components/keepMaterialAdmin.vue"
export default component.exports